<template>
  <main>
    <span class="iconfont"></span>
    <div class="header" :class="{login: $route.name == 'Login', edm: $route.name == 'Edm'}">
      <div class="center">
        <div class="left logo" :class="[$route.meta.is_out ? '' : 'link']" @click="toIndex">
          <img src="@/assets/image/2025/logo-login.png" alt="logo" v-if="$route.name == 'Login'">
          <img :src="logo" alt="logo" v-else>

        </div>
        <div class="right menu-box" v-if="!$route.meta.is_out">
          <div class="left menu">
            <div class="left item" :class="[item.min ? 'more' : '',item.link == route_path ? 'active' : '']" v-for="item in menu">
              <div class="tit" @click="toMenu(item)">{{ item.title }}</div>
              <div class="ll" v-if="item.min" :class="[hidden ? 'hidden' : '']">
                <div class="li" v-for="val in item.min" :class="[val.link == route_path ? 'active' : '']" @click="toMenu(val)">{{ val.title }}</div>
              </div>
            </div>
          </div>
          <div class="right action">
            <div class="left login-btn" v-if="!user_info.id">
              <div class="tit" @click="toLogin"><span>登录</span></div>
            </div>
            <div class="left user-info" v-if="user_info.id">
              <div class=" tit">{{ user_info.username || "Dell用户" }}</div>
              <div class="exit-btn" @click="exitUser"><span>退出</span></div>
            </div>
            <div class="left register-btn" v-if="!user_info.id && false">
              <div class="tit" @click="toRegister"><span>报名</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      logo: require("@/assets/image/2025/logo.png"),
      hidden: false,
      boothMenu: [], // 线上展区菜单（接口填充）
    };
  },
  components: {},
  computed: {
    user_info() {
      if (this.$store.state.user_info.id) {
        // // 登录用户变量
        var gioParams = {
          //area_ppl: (this.$store.state.user_info.province + this.$store.state.user_info.city) || "",//省份,城市
          //companyName_ppl: this.$store.state.user_info.company || "",//公司名称
          //companyScale_ppl: "",//公司规模
          //email_ppl: this.$store.state.user_info.email || "",//邮箱
          //industry_ppl: this.$store.state.user_info.job || "",//行业
          phone_ppl: this.util.encryptPhone(this.$store.state.user_info.mobile) || ""//手机
          //userName_ppl: this.$store.state.user_info.username || "",//姓名
          //userRole_ppl: "",//职位
        };
        gio("people.set", gioParams);
        //登录用户ID
        gio("setUserId", this.$store.state.user_info.id);
        //登录用户类型
        gio("track", "loginSuccess", {
          "user_Id": this.$store.state.user_info.memberId,  // memberId
          "phoneNumber": this.util.encryptPhone(this.$store.state.user_info.mobile), //登录手机号
          "loginType": "短信" // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
        });
      }
      return this.$store.state.user_info;
    },
    menu() {
      var _arr = [];
      if (this.util.isOffline()) {//线下
        _arr = [
          {title: "首页", link: "/"},
          {title: "主会场", link: "/plan" /*已放开*/},
          {title: "分论坛", link: "/branch"},
          {title: "线下活动", link: "/offline"},
          {
            title: "线上展区", min: this.boothMenu
          },
          // {
          //   title: "线上展区", coming_soon: false, min: [
          //     {title: "ESG展区", link: "https://www.dell.com/zh-cn/dt/corporate/social-impact.htm", target: "_blank"},
          //     {title: "出海展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/goglobal", target: "_blank"},
          //     {title: "服务展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/service", target: "_blank"},
          //     {title: "OEM 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/oem", target: "_blank"},
          //     {title: "行业展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/manufacture", target: "_blank"},
          //     {title: "外星人展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/alienware", target: "_blank"},
          //     {title: "CSG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/dellpro", target: "_blank"},
          //     {title: "ISG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/sdi-hci", target: "_blank"}
          //   ]
          // },
          // {title:"互动专区",min:[{title:"资料下载",link:"/interact/download"}]},
          {title: "赞助商", link: "/contact/sponsor" /*已放开*/},
          {
            title: "联系我们",
            min: [{title: "联系戴尔", link: "/contact/dell"}, {title: "调查问卷", link: "/interact/paper"}, {title: "社交媒体", link: "/contact/media"}]
          },
          {title: "我的日程", link: "/ucenter/plan", auth: true, coming_soon: false},
        ];
      } else {
        _arr = [
          {title: "首页", link: "/"},
          {title: "主会场", link: "/plan" /*已放开*/},
          {title: "分论坛", link: "/branch"},
          {
            title: "线上展区", min: this.boothMenu
          },
          // {
          //   title: "线上展区", coming_soon: false, min: [
          //     {title: "ESG展区", link: "https://www.dell.com/zh-cn/dt/corporate/social-impact.htm", target: "_blank"},
          //     {title: "出海展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/goglobal", target: "_blank"},
          //     {title: "服务展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/service", target: "_blank"},
          //     {title: "OEM 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/oem", target: "_blank"},
          //     {title: "行业展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/manufacture", target: "_blank"},
          //     {title: "外星人展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/alienware", target: "_blank"},
          //     {title: "CSG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/dellpro", target: "_blank"},
          //     {title: "ISG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/sdi-hci", target: "_blank"}
          //   ]
          // },
          // {title:"互动专区",min:[{title:"资料下载",link:"/interact/download"}]},
          {title: "赞助商", link: "/contact/sponsor" /*已放开*/},
          {
            title: "联系我们",
            min: [{title: "联系戴尔", link: "/contact/dell"}, {title: "调查问卷", link: "/interact/paper"}, {title: "社交媒体", link: "/contact/media"}]
          },
          {title: "我的日程", link: "/ucenter/plan", auth: true, coming_soon: false}
        ];
      }
      return _arr;
    },
    route_path() {
      return this.$route.path;
    }
  },
  methods: {
    toMenu(item) {
      if (!item.min) {
        if (item.coming_soon) {
          // 显示敬请期待弱提示
          this.$toast('敬请期待');
        } else if (!item.link) {
          this.util.showWait(true);
        } else {
          if (item.auth && !this.util.getAccessToken()) {
            this.util.showAuth({
              show: true,
              from: item.link
            });
          } else {
            if (item.target && item.target == "_blank") {
              this.util.toLink(item.link, {}, "_blank");
            } else {
              this.util.toLink(item.link);
            }
            if (item.check_hidden) {
              this.hidden = true;
              setTimeout(() => {
                this.hidden = false;
              }, 100);
            }
          }
        }
      }
    },
    toIndex() {
      if (!this.$route.meta.is_out) {
        this.util.toLink("/");
      }
    },
    exitUser() {
      this.$router.replace({
        path: "/exit",
        query: {
          from: this.$route.fullPath
        }
      });
    },
    toLogin() {
      this.util.toLink("/login", {
        from: this.$route.query.from ?
            this.$route.query.from :
            (this.$route.path == "/login" || this.$route.path == "/register") ? "/" : this.$route.fullPath
      });
    },
    toRegister() {
      gio("track", "DTF2021_hometop_signup");
      this.util.toLink("/register", {
        from: this.$route.query.from ?
            this.$route.query.from :
            (this.$route.path == "/login" || this.$route.path == "/register") ? "/" : this.$route.fullPath
      });
    },
    getList() {
      // 该接口为公开的线上展区菜单，不经过 /dtf-b，且不带鉴权。
      // 用原生 fetch 发 GET 简单请求(不带自定义头)，规避 CORS 预检被拦截(Token 头不在服务端允许列表)，
      const tyle = this.util.isOffline() ? "offline" : "online";
      fetch(`https://www.dellemc-solution.com/api/dtf/booth/menu?tyle=${tyle}`, { method: "GET" })
        .then(r => r.json())
        .then(res => {
          const list = (res && res.data) || [];
          // 只取一级展区（丢弃二级 min），外链统一新开标签页
          this.boothMenu = list.map(x => ({
            title: x.title,
            link: x.link,
            target: /^https?:\/\//.test(x.link || "") ? "_blank" : ""
          }));
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.query = this.$route.query;
    this.getList();
  },
};
</script>
<style type="text/css">
.header {border-bottom: none!important;}
</style>
<style lang="scss" type="text/scss" scoped>
    .header{position: fixed;top:0;left:0;width: 100%;height:80px;text-align: center;color: #fff;border-bottom: none;z-index: 100;
        .center{display: inline-block;width: 1200px;
            .logo{width:280px;margin-top: 13px;
                img{display: block;width: 100%;height:100%;object-fit: contain;}
            }
            .logo.link{cursor: pointer;}
            .menu-box{
                .menu{
                    .item{position: relative; cursor: pointer;transition: all .3s ease;color: #ffffff;
                        .tit{height:60px;padding: 0 12px;line-height: 60px;font-size: 16px;position: relative}
                        .tit::after{content: "";display:block;position: absolute;width: 20px;height:4px;background: #ffffff;bottom:0;left:50%;margin-left: -10px;opacity: 0;}
                        .ll{padding: 10px 20px; display: none;background: #fff;position: absolute;left:0;top:55px;
                            .li{height:35px;line-height: 35px;color: #000;text-align: left;word-break: keep-all;white-space: pre;}
                            .li.active{color:#0170c3;transition: all .3s ease;}
                            .li:hover{color:#0170c3;transition: all .3s ease;}
                        }
                        .ll::after{content: "";display: block;position: absolute;top:-8px;left:30px;margin-left: -10px;width: 0;height:0; border-left:10px solid transparent;border-right: 10px solid transparent;border-bottom:10px solid #fff;}
                    }
                    .item:hover,.item.active{
                        .tit{font-weight: bold;transition: all .3s ease;}
                        .tit::after{opacity: 1; transition: all .3s ease;}
                    }
					.item:hover{
						.ll{display:block;}
						.ll.hidden{display: none;}
					}
                    .item.more{
                        .tit{/*padding-right: 20px;background: url("~@/assets/image/2.png") no-repeat right center;background-size:14px;*/transition: all .3s ease;}
                    }
                    .item.more:hover{
                        .tit{/*background-image: url("~@/assets/image/19.png");background-size:14px;*/transition: all .3s ease;}
                    }
                }
                .action{margin-left: 20px;font-size: 16px;
                    .login-btn{padding: 0 10px; height:33px;margin-top: 13px; line-height:33px;text-align: center;font-size: 16px;cursor: pointer;transition: all .3s ease;position: relative;color: rgba(255,255,255,.8);border: 1px solid #fff;background:rgba(22, 50, 168,.6) ;margin-right: 20px;
                        span{padding-left: 28px;background: url("~@/assets/image/88.png") no-repeat left center;background-size: 18px;}
                    }
                    .login-btn:hover{background:rgba(15,37,73,.3) ;transition: all .3s ease;}
                    .user-info{height:80px;line-height:60px;text-align: center;cursor: pointer;transition: all .3s ease;color: #fff;
                        .tit{float: left; height:33px;line-height: 33px;margin-top: 13px; border:1px solid rgba(0,0,0,0); padding-left:28px;background: url("~@/assets/image/2024/icon05.png") no-repeat left center;background-size: 18px;padding-right: 10px;max-width:130px;overflow: hidden;font-size: 16px;}
                        .exit-btn{float: left;padding: 0 10px;height:33px;margin-top: 13px; line-height:33px;text-align: center;font-size: 16px;cursor: pointer;transition: all .3s ease;position: relative;color: rgba(255,255,255,.8);border: 1px solid #fff;background:rgba(15,37,73,.6) ;
                            span{padding-left:28px;background: url("~@/assets/image/89.png") no-repeat left center;background-size:18px;}
                        }
                        .exit-btn:hover{background:rgba(15,37,73,.3) ;transition: all .3s ease;}
                    }
                    .register-btn{padding: 0 10px;height:33px;margin-top: 13px; line-height:33px;text-align: center;font-size: 16px;cursor: pointer;transition: all .3s ease;position: relative;color: rgba(255,255,255,.8);border: 1px solid #fff;background:rgba(15,37,73,.6) ;
                        span{padding-left:28px;background: url("~@/assets/image/87.png") no-repeat left center;background-size:18px;}
                    }
                    .register-btn:hover{background:rgba(15,37,73,.3) ;transition: all .3s ease;}
                    .lang{width: 70px;height:80px;line-height:80px;text-align: center;font-size: 16px;cursor: pointer;transition: all .3s ease;position: relative;display: none;
                        .tit{margin-left: 15px; padding-left:6px;background: url("~@/assets/image/46.png") no-repeat left center;background-size: 16px;}
                        .ll{padding:10px; background: #fff;position: absolute;left:15px;top:80px;display: none;
                            .li{height:35px;line-height: 35px;color: #000;text-align: left;}
                            .li.active{color:#0170c3;transition: all .3s ease;}
                            .li:hover{color:#0170c3;transition: all .3s ease;}
                        }
                    }
                    .lang:hover{
                        .ll{display: block;}
                    }
                }
            }
        }
    }
    .header.edm{position: absolute;}
    .header.login {
      .center {
        .menu-box {
          .menu {
            .item {
              color: #000;
              .tit::after{background: #000000;}
            }
          }
          //.action{
          //  .login-btn {
          //    border: 1px solid #000;background:rgba(15,37,73,.2) ;
          //  }
          //}
        }
      }
    }
</style>

